module.exports = __webpack_public_path__ + "img/dropdown.3b5b20eb.svg";